<form #form="ngForm" (ngSubmit)="login()">
  <div class="Frame11"
    style="flex-direction: column; justify-content: center; align-items: center; gap: 4vh; display: flex">
    <div class="Frame53"
      style="align-self: stretch; height: 276px; flex-direction: column; justify-content: center; align-items: center; gap: 32px; display: flex">
      <div class="Frame32"
        style="align-self: stretch; height: 26px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
        <div class="Formlabel"
          style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
          <div class="Label"
            style="color: rgba(0, 0, 0, 0.87); font-size: 15px; font-family: Roboto; font-weight: 500; text-transform: uppercase; line-height: 26px; letter-spacing: 0.46px; word-wrap: break-word">
            Login</div>
        </div>
      </div>
      <div class="from-body">
        <div class="form-elements">
          <mat-form-field appearance="outline">
            <mat-label>Email address</mat-label>
            <input matInput type="email" [formControl]="emailFormControl" required>
            <mat-error *ngIf="emailFormControl.hasError('email')
                              && !emailFormControl.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="emailFormControl.hasError('required')">
              Email is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput [formControl]="passwordFormControl" [type]="hide ? 'password' : 'text'" required>
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off': 'visibility'}}</mat-icon>
            <mat-error *ngIf="passwordFormControl.hasError('required')">
              Password is required
            </mat-error>
          </mat-form-field>
        </div>
        <button class="submit-button" [disabled]="form.invalid || isLoading" type="submit">
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          Login
          @if (!isLoading) {
            <mat-icon iconPositionEnd class="arrow-icon" svgIcon="arrow-icon"></mat-icon>
          }
        </button>
      </div>
    </div>
    <div class="login-form-footer ">
      <mat-checkbox class="" color="primary" value="after">Remember me</mat-checkbox>
      <div class="Button"
        style="align-self: stretch; height: 42px; padding-left: 8px; padding-right: 8px; border-radius: 4px; overflow: hidden; flex-direction: column; justify-content: center; align-items: flex-start; display: flex">
        <div class="Base" style="justify-content: center; align-items: center; gap: 8px; display: inline-flex">
          <a routerLink="/auth/request-password-change" class="Button"
            style="color: #2196F3; font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 28px; letter-spacing: 0.15px; word-wrap: break-word">Forgot
            your password ?</a>
        </div>
      </div>
    </div>
  </div>
</form>